module.exports = __webpack_public_path__ + "static/media/iar_vehicle_ems.664bf24a.svg";